var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadChaoPhi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1362_24647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9437 11.2627C16.8425 11.039 16.62 10.8965 16.375 10.8965H13.875V2.77148C13.875 2.42648 13.595 2.14648 13.25 2.14648H10.75C10.405 2.14648 10.125 2.42648 10.125 2.77148V10.8965H7.62495C7.37995 10.8965 7.15745 11.0402 7.0562 11.2627C6.9537 11.4865 6.9937 11.7477 7.15495 11.9327L11.53 16.9327C11.6487 17.069 11.82 17.1465 12 17.1465C12.18 17.1465 12.3512 17.0677 12.47 16.9327L16.845 11.9327C17.0075 11.749 17.045 11.4865 16.9437 11.2627Z",
    fill: "#1A427D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.875 15.8965V19.6465H5.125V15.8965H2.625V20.8965C2.625 21.5877 3.185 22.1465 3.875 22.1465H20.125C20.8162 22.1465 21.375 21.5877 21.375 20.8965V15.8965H18.875Z",
    fill: "#1A427D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1362_24647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2.14648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadChaoPhi);
export default __webpack_public_path__ + "static/media/download-chao-phi.fa889121b6ec62939593d79e318e4e11.svg";
export { ForwardRef as ReactComponent };